module.exports = __webpack_public_path__ + "static/media/ball_3_0.a84fcfdb.mp3";